import React, {useEffect} from 'react';
import {useHistory, useLocation} from 'react-router-dom'
import siteUrl from "../config";
import utils from "../utils/index";

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}

function Authorize(props) {
    let query = useQuery();
    let access_token = localStorage.getItem("access_token");
    let tutor_access_token = localStorage.getItem("tutor_access_token");
    let tutor_role = localStorage.getItem("tutor_role");
    let role = localStorage.getItem("role");
    let isLogout = !!query.get('logout');
    let isLogin = !!query.get('login')
    let login_role = query.get('login_role');
    let logout_role = query.get('role');
    const history = useHistory();

    function logout() {
        console.log("Logout Start", logout_role)
        if (logout_role === "sadmin" || logout_role === "student") {
            localStorage.removeItem('access_token');
            localStorage.removeItem('role');
            localStorage.removeItem('name');
        } else if (logout_role === "professor") {
            localStorage.removeItem('tutor_access_token');
            localStorage.removeItem('tutor_role');
            localStorage.removeItem('tutor_name');
            localStorage.removeItem('tutor_loggedin');
        }
        console.log("Logout LocalStorage Cleared!")
        console.log("Logout End")
    }

    function redirectToHome() {
        console.log("Redirect to Home Start")
        history.push('/');
        console.log("Redirect to Home End")
    }

    function redirectSignin() {
        console.log("Redirect to Sign Start")
        console.log("Role", logout_role)
        if (logout_role === "professor") {
            history.push('/pro');
        } else {
            history.push('/student-signin');
        }
        console.log("Redirect to Sign End")
    }

    useEffect(() => {
        console.log("Authorize - Use Effect",isLogin,login_role,isLogout)
        if (isLogin && login_role && !isLogout) {
            console.log("isLogin && login_role")
            if (login_role === "professor") {
                console.log("isLogin && login_role - professor")
                if(tutor_access_token){
                utils.redirectWithToken(siteUrl.tutor_url, tutor_access_token, tutor_role);}else {
                    history.push('/tutor-signin')
                }
            } else {
                console.log("isLogin && login_role - else")
            }
        } else if ((access_token || tutor_access_token) && !isLogout) {
            console.log("(access_token || tutor_access_token) && !isLogout")
            if (role === "schooladmin") {
                utils.redirectWithToken(siteUrl.sadmin_url, access_token, role);
            } else if (role === "student") {
                utils.redirectWithToken(siteUrl.student_url, access_token, role);
            } else if (role === "professor") {
                utils.redirectWithToken(siteUrl.tutor_url, tutor_access_token, tutor_role);
            } else {
                // alert("Invalid User Role");
                redirectSignin();

            }
        } else if (isLogout) {
            console.log("Else If isLogout Start")
            logout();
            redirectSignin();
            console.log("Else If isLogout End")
        } else {
            //    No query params
            redirectSignin();
            console.log("useEffect Else")
        }
    }, []);

    return (
        <React.Fragment>
            <div>
            </div>
        </React.Fragment>
    );
}

export default Authorize